import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cm-extraction',
    templateUrl: './extraction.component.html',
    styleUrls: ['./extraction.component.css']
})
export class ExtractionComponent implements OnInit {

    constructor() { }

    ngOnInit() {

    }

}
